module.exports = __webpack_public_path__ + "static/media/icon-button-detail.f6706f1e.svg";